import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import CameraHeader from './components/CameraHeader';
import PaginaRicerca from "./components/PaginaRicerca";
//import FlagTrail from "./components/Flag";

const App = () => {

  return (
    <CameraHeader>

      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<PaginaRicerca />} />
          <Route path="*" element={<Navigate to="/" replace />} />


        </Routes>
      </BrowserRouter>
    </CameraHeader>
  )
};

export default App;